import { queryOptions, useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { QUERY_KEYS } from '~shared/api/query-keys';

export interface AttendanceAnalysis {
  name: string;
  studio: string;
  total: number;
  absentCount: number;
  classes: Array<DanceClass>;
  absentPercent: number;
}

export interface DanceClass {
  className: string;
  classId: string;
  absentCount: number;
}

export interface GetAttendanceAnalysisParams {
  groupBy: 'className' | 'groupName';
  sessionId: string;
}

export const getAttendanceAnalysisAPI = async (
  params: GetAttendanceAnalysisParams,
) => {
  const response = await baseAPI.get<Array<AttendanceAnalysis>>(
    `/dashboard/absent-stats/${params.sessionId}`,
    {
      params: {
        groupBy: params.groupBy,
      },
    },
  );
  return response.data;
};

export const getAttendanceAnalysisQueryOptions = (
  params: GetAttendanceAnalysisParams,
) =>
  queryOptions({
    queryKey: [QUERY_KEYS.ATTENDANCE_ANALYSIS, params],
    queryFn: () => getAttendanceAnalysisAPI(params),
  });

export const useGetAttendanceAnalysis = (
  params: GetAttendanceAnalysisParams,
) => {
  return useQuery(getAttendanceAnalysisQueryOptions(params));
};
